import { render, staticRenderFns } from "./PageContentImage.vue?vue&type=template&id=71e21710"
import script from "./PageContentImage.vue?vue&type=script&lang=js"
export * from "./PageContentImage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports